import { apiRequest } from "@/data/api/client";
import {
  payloadToConfirmedReservation,
  payloadToPartnerReservation,
  payloadToRecordedArrival,
  payloadToReservationLookup,
  type ConfirmedReservationPayload,
  type PartnerReservationPayload,
  type RecordedArrivalPayload,
  type ReservationLookupPayload,
} from "@/data/mappers/partnerReservation.mapper";
import type {
  ConfirmedReservation,
  PartnerReservation,
  RecordedArrival,
  ReservationLookup,
} from "@/domain/reservation/types";

export const partnerReservationsRepo = {
  async list(): Promise<PartnerReservation[]> {
    const payloads = await apiRequest<PartnerReservationPayload[]>("/v1/partner/reservations");
    return payloads.map(payloadToPartnerReservation);
  },

  async confirm(reservationId: number): Promise<ConfirmedReservation> {
    const payload = await apiRequest<ConfirmedReservationPayload>(
      `/v1/partner/reservations/${reservationId}/confirm`,
      { method: "POST" },
    );
    return payloadToConfirmedReservation(payload);
  },

  async lookup(code: string): Promise<ReservationLookup> {
    const payload = await apiRequest<ReservationLookupPayload>(
      `/v1/partner/reservations/lookup?code=${encodeURIComponent(code)}`,
    );
    return payloadToReservationLookup(payload);
  },

  async recordArrival(reservationId: number): Promise<RecordedArrival> {
    const payload = await apiRequest<RecordedArrivalPayload>(
      `/v1/partner/reservations/${reservationId}/validate`,
      { method: "POST" },
    );
    return payloadToRecordedArrival(payload);
  },

  async reject(reservationId: number): Promise<void> {
    await apiRequest(`/v1/partner/reservations/${reservationId}/reject`, { method: "POST" });
  },

  async cancel(reservationId: number): Promise<void> {
    await apiRequest(`/v1/partner/reservations/${reservationId}/cancel`, { method: "POST" });
  },
};
